import { t } from '@figma/i18n/translation'
import {
  cookiesDoNotSellOrShare,
  cookiesManageCookiesOptOut,
} from '@figma/i18n-dictionaries/en/web/cookies'
import { atomStore } from '@figma/jotai'

import { localizePath } from 'shared/i18n/helpers'

import {
  canUseCookieForAnalyticsAtom,
  canUseCookieForFunctionalAtom,
  canUseCookieForMarketingAtom,
} from './cookie_banner_atoms'

export type CookieConsentKeys = 'analytics' | 'marketing' | 'functional'

export enum ConsentRegionType {
  IMPLICIT = 'implicit',
  EXPLICIT = 'explicit',
}

export function getCookiePreferenceForUseCase(useCase: CookieConsentKeys): boolean {
  switch (useCase) {
    case 'analytics':
      return atomStore.get(canUseCookieForAnalyticsAtom)
    case 'marketing':
      return atomStore.get(canUseCookieForMarketingAtom)
    case 'functional':
      return atomStore.get(canUseCookieForFunctionalAtom)
  }
}

export function ManageCookiesText(consentRegion?: ConsentRegionType) {
  if (consentRegion === ConsentRegionType.IMPLICIT) {
    return t(cookiesDoNotSellOrShare)
  }
  return t(cookiesManageCookiesOptOut)
}

export function ManageCookiesUrl(consentRegion?: ConsentRegionType) {
  if (consentRegion === ConsentRegionType.IMPLICIT) {
    return '/opt-out/'
  }
  return localizePath('/consent-preferences/')
}
